import { useState } from "react";
import {Button, PrimaryButton} from "../components/Buttons";
import { TextAreaInput, TextInput } from "../components/Inputs";
import { useUserStore } from "../context";
import { useAlert, useApi } from "../hooks";
import { PageHeader } from "../components/Layouts";
import { isValidEmail } from "../utils/helpers";

export default function ContactUs() {
    const alert = useAlert();
    const { post } = useApi();
    const { currentUser } = useUserStore();
    const [email, setEmail] = useState(currentUser?.email || "");
    const [name, setName] = useState(tryGetFullname() || "");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [saving, setSaving] = useState(false);
    function tryGetFullname() {
        if (!currentUser) return undefined;
        if (!currentUser.firstName && !currentUser.lastName) return undefined;
        return `${currentUser.firstName} ${currentUser.lastName}`;
    }
    function isValid() {
        if (!name) {
            alert("Name required", "", "warning");
            return false;
        }
        if (!email || !email.trim() || !isValidEmail(email)) {
            alert("Email required", "", "warning");
            return false;
        }
        if (!subject) {
            alert("Subject required", "", "warning");
            return false;
        }
        if (!message) {
            alert("Message required", "", "warning");
            return false;
        }
        return true;
    }
    function submit() {
        if (saving || !isValid()) return;
        setSaving(true);
        post("user/contactUs", {
            name,
            email,
            subject,
            message
        })
        .then(res => {
            alert("Message sent", "", "success");
        })
        .catch(err => {
            alert("Server error", "Unable to send message", "error");
        })
        .finally(() => {
            setSaving(false);
        });
    }
    return (
        <div className="w-4/5 lg:w-1/3 min-w-[30vw] my-auto flex flex-col gap-4 place-self-center ml-10">
            <PageHeader title={"Contact Us"}  className={"[&&]:ml-0"}/>
            <TextInput
                label={"Name"}
                value={name}
                onChange={e => {
                    setName(e.target.value);
                }}
                disabled={!!currentUser?.firstName || !!currentUser.lastName}
                required
            />
            <TextInput
                label={"Email"}
                value={email}
                onChange={e => {
                    setEmail(e.target.value);
                }}
                disabled={!!currentUser?.email}
                required
            />
            <TextInput
                label={"Subject"}
                value={subject}
                onChange={e => {
                    setSubject(e.target.value);
                }}
                required
            />
            <TextAreaInput
                label={"Message"}
                value={message}
                onChange={e => {
                    setMessage(e.target.value);
                }}
                required
            />
            <div className="border-b"/>
            <Button
                text={"Submit"}
                onClick={submit}
            />
        </div>
    )
}